<template>
    <div class="modal fade" :id="id" tabindex="-1" role="dialog" :aria-labelledby="id + 'Label'" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">

                <div class="modal-header">
                    <h5 class="modal-title" :id="id + 'Label'">Carnet d'adresses
                        <span v-if="'shipping' === type">de livraison</span>
                        <span v-if="'billing' === type">de facturation</span>
                    </h5>

                    <button @click="back" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div v-if="!isNewAddress && !isEditAddress" class="blockAddressesBook">
                        <div class="itemAddressesBook" :data-id="item.id" v-for="item in filteredAddresses">
                            <div class="float-right">
                                <div class="btn btn-primary btnEdit" @click="editAddress(item)"><img src="/bundles/site/img/icoEdit.svg" alt="Modifier" class="svg"></div>
                                <div class="btn btn-primary btnDelete" @click="deleteAddress(item.id)"><img src="/bundles/site/img/icoSupprimer.svg" alt="Supprimer" class="svg"></div>
                                <div class="btn btn-primary btnChoose" @click="selectAddress(item)">Choisir</div>
                            </div>
                            <ul>
                                <li class="headerTitle">
                                    <i class="fa fa-home"></i>
                                    {{ item.title }}
                                </li>
                                <li>{{ item.firstname }} {{ item.lastname }}</li>
                                <li>{{ item.number }} {{ item.address1 }}</li>
                                <li>{{ item.zipcode }} {{ item.city }}</li>
                                <li>{{ item.country.name }}</li>
                                <li>{{ item.phone }}</li>
                            </ul>
                        </div>
                        <div v-if="filteredAddresses.length === 0">
                            Vous n'avez pas d'adresses
                        </div>
                    </div>
                    <div v-show="isNewAddress || isEditAddress">
                        <form :id="slotName" :name="formName" method="post" novalidate="novalidate" autocomplete="off" v-on:submit.prevent="submitAddress">
                            <slot :name="slotName"/>
                            <div class="text-center">
                                <button id="addressSubmit" type="submit" class="btn btn-primary">Valider</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" v-if="showBack()" @click="back">Retour</button>
                    <button type="button" class="btn btn-primary" v-if="!isNewAddress && !isEditAddress" @click="newAddress()">Ajouter une adresse</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import store from '../../store';
    import {mapState, mapActions, mapGetters} from 'vuex';

    const OrderAddressesModal = {
        name: 'ponroy-addresses-modal',
        store,
        props: {
            id : {
                type: String,
                required: true,
            },
            slotName : {
                type: String,
                required: true,
            },
            formName : {
                type: String,
                required: true,
            },
            type : {
                type: String,
                required: true,
            },
        },

        data: function() {
            return {
                isNewAddress: false,
                isEditAddress : false,
                isSubmit : false,
                currentEditAddress : {},
            }
        },

        computed: {
            ...mapGetters('order', [
                'addresses',
                'shippingAddress',
                'generalAddressErrors',
                'billingAddress',
                'isSameAddress',
                'isLoadingAddresses',
                'isLoadingShippingAddress',
                'invalidAddress',
            ]),

            filteredAddresses() {
                let type = this.type;

                return this.addresses.filter(item => {
                    if ('billing' === type) { return 'billing' === item.type; }
                    if ('shipping' === type) { return 'shipping' === item.type || null === item.type; }
                });
            }
        },
        methods: {
            ...mapActions('order', [
                'getShippingAddress',
                'getBillingAddress',
                'deleteShippingAddress',
                'deleteBillingAddress',
                'addGeneralAddress',
            ]),

            back() {
                this.isNewAddress = false;
                this.isEditAddress = false;
                this.isSubmit = false;
                this.currentEditAddress = {};
            },

            newAddress(){
                this.cleanAddress();
                this.isNewAddress = true;
            },

            selectAddress(item) {
                this.cleanAddress();

                if (this.type === 'billing') {
                    this.getBillingAddress(item.id);
                } else {
                    this.getShippingAddress(item.id);
                }

                $('#' + this.id).modal('hide');
            },

            editAddress(item) {

                this.cleanAddress();

                $("input[name='" + this.formName + "[civility]'][value=" + item.civility + "]").prop('checked', true);

                for(let k in item) {
                    let input = document.getElementById(this.formName + "_" + k);
                    if (input) {
                        if ('country' === k) {
                            input.value = item[k].id;
                        } else {
                            input.value = item[k];
                        }
                    }
                }

                this.isEditAddress = true;
                this.currentEditAddress = item;
            },

            deleteAddress(id) {
                if ('shipping' === this.type) {
                    this.deleteShippingAddress(id);
                } else if ('billing' === this.type) {
                    this.deleteBillingAddress(id);
                }
            },

            submitAddress(event) {
                event.preventDefault();
                let formData = this.serialize(event.target);
                this.isSubmit = true;
                this.addGeneralAddress({formData, id : this.currentEditAddress.id});
            },

            cleanAddress() {
                for(let k in this.addresses[0]) {
                    let input = document.getElementById(this.formName + "_" + k);
                    if (input && input.type !== 'hidden') { input.value = ''; }
                }

                this.$store.commit('order/SET_GENERAL_ADDRESS_ERRORS', {});
            },

            showBack() {
                if (!this.isNewAddress && !this.isEditAddress) { return false; }
                if (this.isNewAddress || this.isEditAddress) { return true; }
                return false;
            },

            serialize(form) {
                let $form = $(form), data = '';
                $form.find('input, select').each(function() {
                    if($(this).attr('type') == 'radio' && !$(this).prop('checked')) { return; }
                    data += $(this).attr('name');
                    data += '=';
                    data += $(this).val();
                    data += '&';
                });

                return data;
            },

            filter(item) {
                if ('billing' === this.type) { return 'billing' === item.type; }
                if ('shipping' === this.type) { return 'shipping' === item.type || null === item.type; }
            },
        },
        watch: {
            generalAddressErrors(value) {
                $('form#' + this.slotName + ' .invalid-feedback').remove();
                $("form#" + this.slotName + " :input").removeClass('is-invalid');

                let lght = Object.keys(value).length;
                if (0 < lght) {
                    let formName = this.formName;
                    $.each(value, function (k, v) {
                        let $input = $("#" + formName + "_" + k);
                        $input.addClass("is-invalid");
                        $input.parent().append('<div class="invalid-feedback"><span class="error">' + v + '</span></div>');
                    });
                }

                if (this.isEditAddress && this.isSubmit && 0 === lght) {
                    this.isEditAddress = false;
                    this.isSubmit = false;

                    if (this.currentEditAddress) {
                        this.selectAddress(this.currentEditAddress);
                        this.currentEditAddress = {};
                    }
                }

                if (this.isNewAddress && this.isSubmit && 0 === lght) {
                    this.isNewAddress = false;
                    this.isSubmit = false;
                }
            },
            invalidAddress(value) {

                if (null !== value) {
                    let type = null === value.type ? 'shipping' : value.type;

                    if (this.type === type) {
                        $('#' + this.id).modal({show: true});
                        this.editAddress(value);
                        this.$store.commit('order/SET_GENERAL_ADDRESS_ERRORS', {'phone' : 'Votre numéro de téléphone doit contenir uniquement des chiffres.'});
                    }
                }
            }
        },
    };

    export default OrderAddressesModal;
</script>


// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/Order/OrderAddressesModal.vue